import GlobalContext from '../bootstrap';
import Discardable from '../property/discard';
import initPropertySliders from '../property/sliders';
import initCharacterLimit from '../characterlimit';
import initUserItemsGrid from '../user/saved-items-grid';
import initTagScrollers from '../property/tag-scroller';
import initPrintable from '../print';
import itemDetailMaps from '../maps/item-map';
import initMortgageCalculator from '../property/mortgage-calculator';
import initPropertyMediaHandler from '../property/media';
import onPopupOpenPropertyContact from '../events/popup-open-property-contact';
import onPopupOpenDirectory from '../events/popup-open-directory';

class UserSavedPage extends GlobalContext {
    constructor() {
        super();
        this._registerEvents();
        this._initialiseComponents();
    }

    _registerEvents(): void {
        window.addEventListener( 'twc:popup:open-directory', onPopupOpenDirectory );

        window.addEventListener( 'twc:popup:open-property-contact', onPopupOpenPropertyContact );
    }

    _initialiseComponents(): void {
        initUserItemsGrid( {
            paginationOptions: {
                countableSelector: '[data-saved-id]',
                ignoreSelector: '.discarded [data-saved-id]',
            },
        } );

        new Discardable();

        initPropertySliders();

        initPropertyMediaHandler( document );

        initMortgageCalculator();

        itemDetailMaps();

        initPrintable();

        initTagScrollers();

        initCharacterLimit();

        const savedFilterForm = document.querySelector<HTMLFormElement>( '#save-filters' );

        if ( savedFilterForm ) {
            savedFilterForm.querySelectorAll( 'select' ).forEach( function( select: HTMLSelectElement ) {
                select.addEventListener( 'change', function() {
                    savedFilterForm.submit();
                } );
            } );
        }
    }
}

if ( !window.userSavedPage ) {
    window.userSavedPage = new UserSavedPage();
}
